'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _base = require('base');

var _base2 = _interopRequireDefault(_base);

var _jQuery = require('jQuery');

var _jQuery2 = _interopRequireDefault(_jQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextArea = function (_BaseField) {
	_inherits(TextArea, _BaseField);

	function TextArea(props) {
		_classCallCheck(this, TextArea);

		var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));

		_this.state = Object.assign(_this.state || {}, { overflowed: false });
		return _this;
	}

	_createClass(TextArea, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return React.createElement(
				'label',
				null,
				React.createElement(
					'span',
					{ className: this.props.labelOutside ? '' : 'sr-only' },
					this.props.label
				),
				React.createElement('textarea', { rows: this.props.rows ? isFinite(this.props.rows) ? this.props.rows : 5 : 5,
					className: this.state.overflowed ? 'overflowed' : '',
					value: this.getValue(),
					onBlur: function onBlur() {
						return _this2.commitValue();
					},
					onChange: function onChange(event) {
						return _this2.updateValue(event.target.value);
					},
					placeholder: this.props.labelOutside ? this.props.placeholder : this.props.label,
					ref: function ref(node) {
						return _this2.textarea = node;
					}
				}),
				React.createElement('div', { className: 'fakeTextarea' + (this.getValue() ? '' : ' fakePlaceholder'), style: { position: 'fixed', right: '150%', top: '0px' }, ref: function ref(node) {
						return _this2.outer = node;
					} })
			);
		}
	}, {
		key: 'updateValue',
		value: function updateValue(value) {
			_get(TextArea.prototype.__proto__ || Object.getPrototypeOf(TextArea.prototype), 'updateValue', this).call(this, value);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			var _get2;

			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			if (_get(TextArea.prototype.__proto__ || Object.getPrototypeOf(TextArea.prototype), 'componentDidUpdate', this)) (_get2 = _get(TextArea.prototype.__proto__ || Object.getPrototypeOf(TextArea.prototype), 'componentDidUpdate', this)).call.apply(_get2, [this].concat(args));
			this._updateHeight();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _get3;

			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}

			if (_get(TextArea.prototype.__proto__ || Object.getPrototypeOf(TextArea.prototype), 'componentDidMount', this)) (_get3 = _get(TextArea.prototype.__proto__ || Object.getPrototypeOf(TextArea.prototype), 'componentDidMount', this)).call.apply(_get3, [this].concat(args));
			this._updateHeight();
		}
	}, {
		key: '_updateHeight',
		value: function _updateHeight() {
			var _this3 = this;

			if (this._outer && this._textarea) {
				var nl = this._outer.childNodes;
				var v = this.getValue();
				if (!v) {
					v = this.props.labelOutside ? this.props.placeholder : this.props.label;
				}
				if (!v) v = "";
				v = v.split('\n');
				for (var i = 0; i < v.length; i++) {
					if (!nl[i]) this._outer.appendChild(document.createElement('div'));
					nl[i].textContent = v[i] || "\xA0";
				}
				while (nl.length > v.length) {
					this._outer.removeChild(nl[nl.length - 1]);
				} // This loop is to account for the case where changing the height results in scrollbars disappearing.
				var w, tgtH, ptgtH;
				var rowCount = this.props.rows || 5;

				do {
					ptgtH = tgtH;
					w = this._textarea.clientWidth;
					this._outer.style.width = this._textarea.clientWidth + 'px';

					// 20 + (26 * 10) + 1 == 10 lines + 10px top & bottom padding + 1px bottom border
					// 47 == 1 line + 10px top & bottom padding + 1px bottom border
					tgtH = Math.min(20 + 26 * rowCount + 1, Math.max(47, this._outer.offsetHeight));
					this._textarea.style.height = tgtH + 'px';
				} while (w != this._textarea.clientWidth && ptgtH != tgtH); // If a loop didn't change the height, don't keep going.

				if (tgtH < this._outer.offsetHeight) {
					if (!this.state.overflowed) {
						this.setState({ overflowed: true });
					}
				} else {
					if (this.state.overflowed) {
						this.setState({ overflowed: false });
					}
				}
				var t = (0, _jQuery2.default)(this._outer).parents('.modal').off('.TextArea');
				if ((0, _jQuery2.default)(this._outer).parents('.modal:not(.in)').length) {
					t.on('show.bs.modal.TextArea showing.bs.modal.TextArea shown.bs.modal.TextArea', function (event) {
						_this3._updateHeight();
					});
				}
			}
		}
	}, {
		key: 'textarea',
		set: function set(v) {
			this._textarea = v;
			//this._updateHeight();
		}
	}, {
		key: 'outer',
		set: function set(v) {
			this._outer = v;
			//this._updateHeight();
		}
	}]);

	return TextArea;
}(_base2.default);

exports.default = TextArea;